import { ApiClient } from "../base";
export class CloudAgentClient extends ApiClient {
    createAgentProfiler(options) {
        const url = "v1/agents/reports";
        return this.base.post(url, options);
    }
    getAgentProfilerStatus(profilerId) {
        return this.base.get(`v1/agents/reports/${profilerId}/status`);
    }
    getAgentProfilerResults(profilerId) {
        return this.base.get(`v1/agents/reports/${profilerId}/results`);
    }
}
